// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary) 50%, var(--accent-dark) 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* Background decorations */
.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%);
  backdrop-filter: blur(5px);
  z-index: 1;
}

.circle-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  right: -100px;
  animation: float 20s infinite ease-in-out;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -150px;
  left: -100px;
  animation: float 15s infinite ease-in-out reverse;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-30px) rotate(5deg); }
}

.login-card {
  width: 100%;
  max-width: 440px;
  background: var(--bg-card);
  border-radius: 24px;
  padding: 32px 36px 24px 36px;
  box-shadow: 0 25px 50px -12px rgba(8, 18, 43, 0.5);
  position: relative;
  z-index: 10;
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  border: 1px solid rgba(255,255,255,0.2);
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  animation: bounceSoft 2s infinite ease-in-out;
}

@keyframes bounceSoft {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

.login-logo-img {
  width: 70px;
  height: 70px;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}

.login-header h1 {
  font-size: 32px;
  font-weight: 800;
  color: var(--primary);
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.login-header .subtitle {
  font-size: 14px;
  color: var(--gray-600);
  margin: 0 0 4px 0;
  font-weight: 500;
}

.login-header .sub-subtitle {
  font-size: 12px;
  color: var(--gray-400);
  margin: 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-700);
  margin-left: 4px;
}

.form-group input {
  padding: 14px 16px;
  border: 2px solid var(--border);
  border-radius: var(--radius);
  font-size: 15px;
  transition: all 0.2s ease;
  background: var(--gray-50);
  color: var(--text);
  outline: none;
}

.form-group input::placeholder {
  color: var(--gray-400);
}

.form-group input:focus {
  border-color: var(--accent);
  background: var(--bg-card);
  box-shadow: 0 0 0 4px var(--accent-light);
}

.btn-login {
  margin-top: 12px;
  padding: 14px;
  background: linear-gradient(to right, var(--primary), var(--primary-light));
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(22, 42, 90, 0.2);
  position: relative;
  overflow: hidden;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(22, 42, 90, 0.3);
  background: linear-gradient(to right, var(--primary), var(--accent));
}

.btn-login:active:not(:disabled) {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-login.btn-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  100% { left: 200%; }
}

.login-error {
  background: var(--danger-light);
  color: var(--danger-dark);
  padding: 12px 16px;
  border-radius: var(--radius);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 24px;
  text-align: center;
  border: 1px solid rgba(185, 28, 28, 0.2);
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  border-top: 1px solid var(--border);
  padding-top: 16px;
}

.login-footer p {
  color: var(--gray-500);
  font-size: 12px;
  margin: 2px 0;
  font-weight: 500;
}

@media (max-width: 480px) {
  .login-card {
    padding: 24px 20px;
    width: 95%;
    border-radius: 16px;
  }
  .login-header h1 {
    font-size: 26px;
  }
  .login-header .subtitle {
    font-size: 13px;
  }
  .login-logo-img {
    width: 55px;
    height: 55px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wGAAwG;EACxG,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uFAAuF;EACvF,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mFAAmF;EACnF,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,wDAAwD;AAC1D;;AAEA;EACE,WAAW,kCAAkC,EAAE;EAC/C,WAAW,iCAAiC,EAAE;EAC9C,gBAAgB,kCAAkC,EAAE;EACpD,WAAW,iCAAiC,EAAE;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary) 50%, var(--accent-dark) 100%);\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Background decorations */\n.bg-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%);\n  backdrop-filter: blur(5px);\n  z-index: 1;\n}\n\n.circle-1 {\n  width: 600px;\n  height: 600px;\n  top: -200px;\n  right: -100px;\n  animation: float 20s infinite ease-in-out;\n}\n\n.circle-2 {\n  width: 400px;\n  height: 400px;\n  bottom: -150px;\n  left: -100px;\n  animation: float 15s infinite ease-in-out reverse;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-30px) rotate(5deg); }\n}\n\n.login-card {\n  width: 100%;\n  max-width: 440px;\n  background: var(--bg-card);\n  border-radius: 24px;\n  padding: 32px 36px 24px 36px;\n  box-shadow: 0 25px 50px -12px rgba(8, 18, 43, 0.5);\n  position: relative;\n  z-index: 10;\n  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n  border: 1px solid rgba(255,255,255,0.2);\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.login-logo {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n  animation: bounceSoft 2s infinite ease-in-out;\n}\n\n@keyframes bounceSoft {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-6px); }\n}\n\n.login-logo-img {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));\n}\n\n.login-header h1 {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--primary);\n  margin: 0 0 8px 0;\n  letter-spacing: -0.5px;\n}\n\n.login-header .subtitle {\n  font-size: 14px;\n  color: var(--gray-600);\n  margin: 0 0 4px 0;\n  font-weight: 500;\n}\n\n.login-header .sub-subtitle {\n  font-size: 12px;\n  color: var(--gray-400);\n  margin: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gray-700);\n  margin-left: 4px;\n}\n\n.form-group input {\n  padding: 14px 16px;\n  border: 2px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 15px;\n  transition: all 0.2s ease;\n  background: var(--gray-50);\n  color: var(--text);\n  outline: none;\n}\n\n.form-group input::placeholder {\n  color: var(--gray-400);\n}\n\n.form-group input:focus {\n  border-color: var(--accent);\n  background: var(--bg-card);\n  box-shadow: 0 0 0 4px var(--accent-light);\n}\n\n.btn-login {\n  margin-top: 12px;\n  padding: 14px;\n  background: linear-gradient(to right, var(--primary), var(--primary-light));\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(22, 42, 90, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-login:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(22, 42, 90, 0.3);\n  background: linear-gradient(to right, var(--primary), var(--accent));\n}\n\n.btn-login:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-login:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-login.btn-loading::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  100% { left: 200%; }\n}\n\n.login-error {\n  background: var(--danger-light);\n  color: var(--danger-dark);\n  padding: 12px 16px;\n  border-radius: var(--radius);\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 24px;\n  text-align: center;\n  border: 1px solid rgba(185, 28, 28, 0.2);\n  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n@keyframes shake {\n  10%, 90% { transform: translate3d(-1px, 0, 0); }\n  20%, 80% { transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }\n  40%, 60% { transform: translate3d(4px, 0, 0); }\n}\n\n.login-footer {\n  margin-top: 20px;\n  text-align: center;\n  border-top: 1px solid var(--border);\n  padding-top: 16px;\n}\n\n.login-footer p {\n  color: var(--gray-500);\n  font-size: 12px;\n  margin: 2px 0;\n  font-weight: 500;\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 24px 20px;\n    width: 95%;\n    border-radius: 16px;\n  }\n  .login-header h1 {\n    font-size: 26px;\n  }\n  .login-header .subtitle {\n    font-size: 13px;\n  }\n  .login-logo-img {\n    width: 55px;\n    height: 55px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
